import React from "react";
import obj from "../../utils/helpers";

const DropDown = ({
  showMatch,
  layData,
  backData,
  data,
  title,
  type,
  type2,
  oldbackData,
  oldlayData,
  res,
}) => {
  const sparkBack = (old, newOdds, index, type) => {
    if (newOdds?.length > 0 && old?.length > 0) {
      if (
        newOdds[index]?.rt != old[index]?.rt ||
        newOdds[index]?.bv != old[index]?.bv
      ) {
        return type == "back" ? "spark-back" : "spark-lay";
      } else {
        return "";
      }
    }
  };
  const renderBackOdds = (selection) => {
    const the_odds = backData;
    const the_odds_old = oldbackData;
    let filter_odds = [];
    let old_filter_odds = [];
    if (title == "Match Odds") {
      filter_odds = the_odds?.filter(
        (todd) => todd.ri === selection?.SelectionId
      );
      old_filter_odds =
        the_odds_old?.length > 0
          ? the_odds_old?.filter((todd) => todd.ri === selection?.SelectionId)
          : [];
    } else {
      filter_odds = the_odds?.filter(
        (todd) => todd.runnerName === selection?.runnerName
      );
      old_filter_odds =
        the_odds_old?.length > 0
          ? the_odds_old?.filter((todd) => todd.ri === selection?.SelectionId)
          : [];
    }
    return (
      <>
        {title == "Match Odds" ? (
          <>
            <td className="back-3 p-0" style={{ cursor: "not-allowed" }}>
              <div
                className={`${sparkBack(
                  filter_odds,
                  old_filter_odds,
                  2,
                  "back"
                )} light-blue rounded-0 spark`}
              >
                <strong>{filter_odds[2]?.rt || "--"}</strong>
                <span className="d-block">{filter_odds[2]?.bv || "--"}</span>
              </div>
            </td>
            <td className="back-2 p-0" style={{ cursor: "not-allowed" }}>
              <div
                className={`${sparkBack(
                  filter_odds,
                  old_filter_odds,
                  1,
                  "back"
                )} light-blue rounded-0`}
              >
                <strong>{filter_odds[1]?.rt || "--"}</strong>
                <span className="d-block">{filter_odds[1]?.bv || "--"}</span>
              </div>
            </td>
          </>
        ) : (
          <>
            <td className="back-3 p-0" style={{ cursor: "not-allowed" }}>
              <div className={`light-blue rounded-0`}>
                <strong>
                  {filter_odds[0]?.rt ? filter_odds[0]?.rt - 2 : "--"}
                </strong>
                <span className="d-block">{filter_odds[0]?.bv || "--"}</span>
              </div>
            </td>
            <td className="back-2 p-0" style={{ cursor: "not-allowed" }}>
              <div className="light-blue rounded-0">
                <strong>
                  {filter_odds[0]?.rt ? filter_odds[0]?.rt - 1 : "--"}
                </strong>
                <span className="d-block">{filter_odds[0]?.bv || "--"}</span>
              </div>
            </td>
          </>
        )}
        <td className="back-1s p-0" style={{ cursor: "not-allowed" }}>
          <div
            className={`${sparkBack(
              filter_odds,
              old_filter_odds,
              0,
              "back"
            )} light-blue rounded-0`}
          >
            <strong>{filter_odds[0]?.rt || "--"}</strong>
            <span className="d-block">{filter_odds[0]?.bv || "--"}</span>
          </div>
        </td>
      </>
    );
  };
  const renderLayOdds = (selection) => {
    const the_odds = layData;
    const the_odds_old = oldlayData;
    let filter_odds = [];
    let old_filter_odds = [];
    if (title == "Match Odds") {
      filter_odds = the_odds?.filter(
        (todd) => todd.ri === selection?.SelectionId
      );
      old_filter_odds = the_odds_old?.filter(
        (todd) => todd.ri === selection?.SelectionId
      );
    } else {
      filter_odds = the_odds?.filter(
        (todd) => todd.runnerName === selection?.runnerName
      );
      old_filter_odds = the_odds_old?.filter(
        (todd) => todd.ri === selection?.SelectionId
      );
    }

    return (
      <>
        <td className="lay-1 p-0" style={{ cursor: "not-allowed" }}>
          <div
            className={`${sparkBack(
              filter_odds,
              old_filter_odds,
              0,
              "lay"
            )} lay-all rounded-0`}
          >
            <strong>{filter_odds[0]?.rt || "--"}</strong>
            <span className="d-block">{filter_odds[0]?.bv || "--"}</span>
          </div>
        </td>
        <td className="lay-2 p-0" style={{ cursor: "not-allowed" }}>
          <div
            className={`${sparkBack(
              filter_odds,
              old_filter_odds,
              1,
              "lay"
            )} dark-pink rounded-0`}
          >
            <strong>{filter_odds[1]?.rt || "--"}</strong>
            <span className="d-block">{filter_odds[1]?.bv || "--"}</span>
          </div>
        </td>
        <td className="lay-2 p-0" style={{ cursor: "not-allowed" }}>
          <div
            className={`${sparkBack(
              filter_odds,
              old_filter_odds,
              0,
              "lay"
            )} dark-pink rounded-0`}
          >
            <strong>
              {filter_odds[0]?.rt ? Math.abs(filter_odds[0]?.rt) : "--"}
            </strong>
            <span className="d-block">{filter_odds[0]?.bv || "--"}</span>
          </div>
        </td>
      </>
    );
  };

  return (
    showMatch && (
      <>
        <tr>
          {["normal", "multi"].includes(type) && type2 == "other" && (
            <td colSpan="2" className="border-l"></td>
          )}
          <td
            colSpan={type == "multi" ? 4 : 3}
            className="px-0 gray-inner_table"
          >
            <div className="head-bets-agent">
              {" "}
              <div>
                Total Stakes{" "}
                <span className="game-matched">PBU {res?.totalStake > 0 ? obj.currencyFormat(res?.totalStake) : 0.0}</span>
              </div>{" "}
              <div>
                Matched <span className="game-matched">PBU 196,161,161</span>
              </div>
            </div>
            <table className="selection-table">
              <tbody className="">
                <tr>
                  <td width="40%" className="text-start border-0 ">
                    {data?.length > 0 && data?.length} selections Selections
                  </td>
                  <td className="refer-bet border-0" colSpan="2" width="30%">
                    100.8%
                  </td>
                  <td className="border-0 p-0" width="15%">
                    <div className="back-blue back-all-size">
                      <span>Back all</span>
                    </div>
                  </td>
                  <td className="border-0 p-0" width="15%">
                    <div className="lay-all back-all-size">
                      <span>Lay all</span>
                    </div>
                  </td>
                  <td
                    className="refer-book border-0"
                    colSpan="2"
                    id="layPercent"
                  >
                    99.5%
                  </td>
                </tr>
                {data?.length > 0 &&
                  data?.map((res, index) => {
                    return (
                      <tr key={index + 1}>
                        <td className="border-start-0">
                          <a>
                            {" "}
                            <img src="../assets/images/icon-chart.png"></img>
                            {/* <i className="far fa-chart-bar pe-2"></i> */}
                            <strong>
                              {" "}
                              {title == "Book Maker"
                                ? res?.runnerName
                                : res?.RunnerName}
                            </strong>
                          </a>
                        </td>
                        {renderBackOdds(res)}
                        {renderLayOdds(res)}
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </td>
          <td width="80" className="border-l"></td>
        </tr>{" "}
      </>
    )
  );
};

export default DropDown;
